import type { SessionsAsset } from '@carboncopyco/data';
import { RecordingTypes } from '@carboncopyco/types';
import { TextBase, TooltipBubble } from '@carboncopyco/ui';
import classNames from 'classnames';
import { Screenshot } from '../../../Screenshot';
import { TableInfoIcon } from '../../TableInfoIcon';
import { getInfoTooltipText } from '../../utils';

export const DemoName = ({ demo }: { demo: SessionsAsset }) => {
  const { name, image, recordingType, status, assetType } = demo;
  const isDisabled = status === 'deleted' || status === 'inactive';

  return (
    <div className="flex items-center">
      <div className="w-7 h-5 shrink-0 mr-3">
        <Screenshot
          isOverlayDemo={recordingType === RecordingTypes.overlay}
          image={image}
          alt="demo"
          rounded="sm"
        />
      </div>

      <div
        className={classNames(
          'flex items-center gap-1.5',
          isDisabled ? 'text-ds-natural-300' : 'text-ds-natural-600'
        )}
      >
        <TooltipBubble
          placement="top-start"
          title={name}
        >
          <div className="truncate max-w-[170px]">
            <TextBase
              color={isDisabled ? 'text-ds-natural-300' : 'text-ds-natural-600'}
              label={name}
            />
          </div>
        </TooltipBubble>
        {isDisabled && (
          <TableInfoIcon label={getInfoTooltipText({ assetType })} />
        )}
      </div>
    </div>
  );
};
